import { render, staticRenderFns } from "./NewRingAuthForm.vue?vue&type=template&id=27db1c12&scoped=true&"
import script from "./NewRingAuthForm.vue?vue&type=script&lang=js&"
export * from "./NewRingAuthForm.vue?vue&type=script&lang=js&"
import style0 from "./NewRingAuthForm.vue?vue&type=style&index=0&id=27db1c12&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27db1c12",
  null
  
)

export default component.exports